module.exports = __webpack_public_path__ + "static/img/Jordan-Riki.bf67190.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete/Jordan-Riki.jpg
// module id = HKZC
// module chunks = 0